module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2019-20.c3924fd3.pdf";